/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import me from '../api/me';
import { ME_QUERY_NAME } from '../constants';
import useCompany from '../../context/CompanyContext';
import { toLocalObject } from '../../lib/utils/companyContextSwitcher';

const useMe = (token: string, meQueryFn?: Function, options?: any) => {
  if (options !== undefined && typeof options !== 'object') {
    throw new Error('The options is not an object');
  }

  const queryOptions = { ...options };
  const queryClient = useQueryClient();
  const companyContext = useCompany();

  const refetch = () => {
    queryClient.invalidateQueries([ME_QUERY_NAME]);
  };

  const query = useQuery(
    [ME_QUERY_NAME],
    () =>
      me(token).then((response) => {
        const localObject = toLocalObject(response.hr_company);
        localObject.id = response.id;
        companyContext.onDataUpdate(localObject);

        if (typeof meQueryFn === 'function') {
          meQueryFn(localObject);
        }

        return response;
      }),
    queryOptions,
  );

  return { ...query, refetch };
};

export default useMe;